import axiosPublic from '@/common/interceptors/axios.PublicInterceptor';

const postPublicPriceAndStock = ({ queryKey: [endpoint, sku] }) => {
  const params = { sku };

  return axiosPublic
    .post(`/api/self-scan-service/${endpoint}`, params)
    .then((res) => res);
};

export default postPublicPriceAndStock;
